import * as React from "react";
import "../../../../assets/scss/components/toc/generic/tocNote/tocNoteTab.scss";

export interface ITocNoteTabProps {}

const TocNoteTab: React.FC<ITocNoteTabProps> = props => {
	const [showPopup, setShowPopup] = React.useState(false);

	return (
		<div className="toc_note_tab ib">
			<button className="note_btn" onClick={() => setShowPopup(true)}>
				Note
			</button>

			{showPopup && (
				<>
					<div className="popup_overlay" onClick={() => setShowPopup(false)} />
					<div className="popup">
						<div className="content">{props.children}</div>
					</div>
				</>
			)}
		</div>
	);
};

export default TocNoteTab;
